/** 유효성 검사 정규식 */

/** @email :@.필수, TDL 2또는 3자*/
export const emailRegExp =
  /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/;

/** @Password :8 ~ 16자 영문, 숫자, 특수문자를 최소 한가지씩 조합 */
export const passwordRegExp =
  /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/;

/** @nickname :한글, 영문 가능, 띄어쓰기 불가*/
export const nicknameRegExp = /^[a-zA-Z0-9ㄱ-힣][a-zA-Z0-9ㄱ-힣]*$/;

/** @artistname :1 ~ 16자 한글, 영문, 숫자 가능, 띄어쓰기 불가*/
export const artistnameRegExp =
  /^(?=.*[a-zA-Z0-9가-힣])[a-zA-Z0-9가-힣]{1,16}$/;

/** @gmail :구글 이메일 */
export const gmailRegExp = /^[A-Za-z0-9]+@gmail.com$/;
